import { render } from "./VideoListCard.vue?vue&type=template&id=23c3e182&scoped=true"
import script from "./VideoListCard.vue?vue&type=script&lang=js"
export * from "./VideoListCard.vue?vue&type=script&lang=js"

import "./VideoListCard.vue?vue&type=style&index=0&id=23c3e182&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c3e182"]])

export default __exports__